import {Stack, Typography} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";


export default function ContextMenuItemLabel(props) {
    const {icon, shortcut, children} = props;

    return (
        <Stack ml={1} mr={1} spacing={1} width="100%" direction="row">
            {icon}
            <Typography pl={1} flexGrow={1} variant="body2">{children}</Typography>
            {shortcut && <Typography pl={3} variant="caption" color="textSecondary" fontWeight="bold">
                {shortcut}
            </Typography>}
        </Stack>
    );
}

ContextMenuItemLabel.propTypes = {
    icon: PropTypes.element,
    shortcut: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
}